function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useApolloClient } from "@apollo/client";
import { useNavigation, useRoute } from "@react-navigation/core";
import { StackActions } from "@react-navigation/native";
import * as Sentry from "@sentry/core";
import equals from "fast-deep-equal";
import { produce } from "immer";
import { useCallback, useEffect, useRef, useState } from "react";
import { Platform } from "react-native";
import { retry } from "@oui/lib/src/retry";
import { Actor, Kind } from "@oui/lib/src/types";
import { useAccessibilityContext } from "../components/AccessibilityContext";
import { IS_PRODUCTION } from "../constants";
import { getEnvelopeDuration, isChatEnvelope, isInputEnvelope, isSideEffectEnvelope } from "../lib/envelopeType";
import { logEvent } from "../lib/log";
import { getMmkv } from "../lib/mmkv";
import { fetchIsConnected } from "../lib/NetInfo";
import { transitionBot } from "../lib/transitionBot";
export var ClientStatus = /*#__PURE__*/ function(ClientStatus) {
    ClientStatus["UNKNOWN"] = "unknown";
    ClientStatus["DISCONNECTING"] = "disconnecting";
    ClientStatus["DISCONNECTED"] = "disconnected";
    ClientStatus["CONNECTING"] = "connecting";
    ClientStatus["CONNECTED"] = "connected";
    return ClientStatus;
}({});
var TEST_CONVO_PREFIX = 'TEST::';
var TEST_CONVO_SPEED_FACTOR = 1;
var BUBBLE_APPEAR_OFFSET = 750;
function getErrorEnvelopes(param) {
    var connected = param.connected;
    return [
        {
            ID: 'error-' + Date.now(),
            kind: Kind.ChatText,
            from: Actor.Bot,
            props: {
                text: connected ? [
                    'Uh oh. Something went wrong.',
                    'Please try again and if your problem persists, come back later.'
                ] : [
                    'Please make sure you are connected to the internet and try again.',
                    'If your problem persists, come back later.'
                ]
            }
        },
        {
            ID: 'error-choice',
            from: Actor.Bot,
            kind: Kind.InputChoice,
            props: {
                max: 1,
                min: 1,
                variant: 'button',
                label: {
                    '0': 'Come back later',
                    '1': 'Try again'
                }
            }
        }
    ];
}
function getFlatChatTextEnvelopesFromChatTextEnvelope(message) {
    var ID = message.ID;
    var props = message.props || [];
    var len = props.text.length;
    var arr = new Array(len);
    for(var i = 0; i < len; i += 1){
        // We manually create a new object vs using immer here because
        // it's not playing nicely with history envlopes loaded from mmkv which
        // are frozen.
        arr[i] = _object_spread_props(_object_spread({}, message), {
            props: _object_spread_props(_object_spread({}, message.props), {
                text: [
                    message.props.text[i]
                ]
            }),
            ID: "".concat(ID, "-").concat(message.from, "-").concat(i, "-").concat(message.t)
        });
    }
    return arr;
}
function useTestMQTT() {
    var timeoutRef = useRef(undefined);
    function sendNextEnvelope(convo, playIndex, callback) {
        var data = require('../_testdata/test.json');
        var currEnvelope = data[playIndex];
        var nextEnvelope = data[playIndex + 1];
        callback(currEnvelope);
        if (nextEnvelope) {
            var delay = nextEnvelope.t && currEnvelope.t ? new Date(nextEnvelope.t).getTime() - new Date(currEnvelope.t).getTime() : 100;
            timeoutRef.current = global.setTimeout(function() {
                sendNextEnvelope(convo, playIndex + 1, callback);
            }, delay / TEST_CONVO_SPEED_FACTOR);
        }
    }
    return {
        send: function(convo, e) {
            console.log('sending', e, 'on', convo);
        },
        status: "connected",
        checkNetworkStatus: function() {
            return Promise.resolve(true);
        },
        subscribe: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(convo, callback) {
                return _ts_generator(this, function(_state) {
                    sendNextEnvelope(convo, 0, callback);
                    return [
                        2
                    ];
                });
            });
            return function(convo, callback) {
                return _ref.apply(this, arguments);
            };
        }(),
        unsubscribe: function() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    };
}
var transitionBotFn = transitionBot;
export function setTransitionBot(_transitionBot) {
    transitionBotFn = _transitionBot;
}
var transitionBotWithRetries = function(client) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var action = args[2];
    if (args[0] === 'e2e-test' && action && 'ID' in action && action.ID === 'mux-body' && action.props === 2) {
        return new Promise(function(_, rej) {
            rej('simulated bot error');
        });
    }
    return retry(function() {
        return transitionBotFn.apply(void 0, [
            client
        ].concat(_to_consumable_array(args)));
    }, {
        timeout: 11000,
        logger: function(message) {
            var _args_;
            Sentry.addBreadcrumb({
                message: 'transitionBot retry result',
                // we dont include client in the ...args pattern above so we dont accidentally
                // try to stringify it and cause a cyclic JSON error
                data: {
                    message: message,
                    config: args[0],
                    stateHash: args[1],
                    actionKind: (_args_ = args[2]) === null || _args_ === void 0 ? void 0 : _args_.kind
                }
            });
        }
    });
};
function cacheBotHistory(convo, history) {
    return _cacheBotHistory.apply(this, arguments);
}
function _cacheBotHistory() {
    _cacheBotHistory = _async_to_generator(function(convo, history) {
        var isInitialRemoteHistory, cachedHistory, fullHistory, newHistory, requiresReset, _cachedHistory_, _cachedHistory__t, latestTimestamp;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    isInitialRemoteHistory = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if (Platform.OS === 'web') {
                        return [
                            2,
                            {
                                newHistory: history,
                                cachedHistory: history,
                                fullHistory: history,
                                requiresReset: false
                            }
                        ];
                    }
                    return [
                        4,
                        getBotHistory(convo)
                    ];
                case 1:
                    cachedHistory = _state.sent();
                    requiresReset = history.length < cachedHistory.length && isInitialRemoteHistory;
                    if (requiresReset) {
                        fullHistory = history;
                        newHistory = history;
                        cachedHistory = [];
                    } else {
                        ;
                        ;
                        latestTimestamp = (_cachedHistory__t = (_cachedHistory_ = cachedHistory[cachedHistory.length - 1]) === null || _cachedHistory_ === void 0 ? void 0 : _cachedHistory_.t) !== null && _cachedHistory__t !== void 0 ? _cachedHistory__t : 0;
                        newHistory = history.filter(function(h) {
                            return h.t > latestTimestamp;
                        }).map(function(h) {
                            return _object_spread_props(_object_spread({}, h), {
                                history: true
                            });
                        });
                        fullHistory = _to_consumable_array(cachedHistory).concat(_to_consumable_array(newHistory));
                    }
                    getMmkv('bot').set(convo, JSON.stringify(fullHistory));
                    return [
                        2,
                        {
                            cachedHistory: cachedHistory,
                            fullHistory: fullHistory,
                            newHistory: newHistory,
                            requiresReset: requiresReset
                        }
                    ];
            }
        });
    });
    return _cacheBotHistory.apply(this, arguments);
}
function getBotHistory(convo) {
    return _getBotHistory.apply(this, arguments);
}
function _getBotHistory() {
    _getBotHistory = _async_to_generator(function(convo) {
        var mmkv, storedValue;
        return _ts_generator(this, function(_state) {
            if (Platform.OS === 'web') return [
                2,
                []
            ];
            mmkv = getMmkv('bot');
            storedValue = mmkv.getString(convo);
            try {
                return [
                    2,
                    storedValue ? JSON.parse(storedValue) : []
                ];
            } catch (e) {
                Sentry.captureException('Failed to restore bot history', {
                    extra: {
                        convo: convo,
                        error: e,
                        storedValue: storedValue,
                        storedValuePrefix: storedValue === null || storedValue === void 0 ? void 0 : storedValue.substring(0, 50)
                    }
                });
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    });
    return _getBotHistory.apply(this, arguments);
}
function useStateMachine(onHistory) {
    var dispatch = useNavigation().dispatch;
    var params = useRoute().params;
    var callbacksRef = useRef({});
    var stateRef = useRef(null);
    var _useState = _sliced_to_array(useState(true), 2), isConnected = _useState[0], setIsConnected = _useState[1];
    var apollo = useApolloClient();
    var checkNetworkStatus = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchIsConnected(1000)
                    ];
                case 1:
                    result = _state.sent();
                    Sentry.addBreadcrumb({
                        category: 'net-info',
                        message: "isConnected?: ".concat(result)
                    });
                    setIsConnected(result);
                    return [
                        2,
                        result
                    ];
            }
        });
    }), []);
    var performTransition = useCallback(function(convo, payload) {
        return transitionBotWithRetries(apollo, convo, stateRef.current, payload).catch(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(e) {
                return _ts_generator(this, function(_state) {
                    if (e.toString() !== 'simulated bot error') {
                        Sentry.captureException('transitionBotWithRetries error', {
                            extra: {
                                data: e
                            }
                        });
                        Sentry.captureException(e);
                    }
                    return [
                        2,
                        {
                            error: true,
                            envelopes: [],
                            state: null
                        }
                    ];
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }()).then(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var error, envelopes, state, _envelopes_, _callbacksRef_current_convo, _ref, newHistory, requiresReset, connected;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            error = param.error, envelopes = param.envelopes, state = param.state;
                            Sentry.addBreadcrumb({
                                category: 'bot',
                                message: 'transition-response',
                                data: {
                                    error: error.toString(),
                                    envelopeIDs: envelopes.map(function(e) {
                                        return e.ID;
                                    }),
                                    state: state
                                }
                            });
                            return [
                                4,
                                cacheBotHistory(convo, envelopes, payload === null)
                            ];
                        case 1:
                            _ref = _state.sent(), newHistory = _ref.newHistory, requiresReset = _ref.requiresReset;
                            if (envelopes === null || envelopes === void 0 ? void 0 : (_envelopes_ = envelopes[0]) === null || _envelopes_ === void 0 ? void 0 : _envelopes_.history) {
                                onHistory(newHistory, requiresReset);
                                return [
                                    2
                                ];
                            }
                            if (!error) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                checkNetworkStatus()
                            ];
                        case 2:
                            connected = _state.sent();
                            Sentry.withScope(function(scope) {
                                scope.setExtras({
                                    state: stateRef.current,
                                    payload: payload
                                });
                                Sentry.captureException('Bot ERROR');
                            });
                            logEvent('bot_error', {
                                state: stateRef.current
                            });
                            envelopes = [
                                {
                                    ID: 'error-' + Date.now(),
                                    kind: Kind.ChatText,
                                    from: Actor.Bot,
                                    props: {
                                        text: connected ? [
                                            'Uh oh. Something went wrong.',
                                            'Please try again and if your problem persists, come back later.'
                                        ] : [
                                            'Please make sure you are connected to the internet and try again.',
                                            'If your problem persists, come back later.'
                                        ]
                                    }
                                },
                                {
                                    ID: 'error-choice',
                                    from: Actor.Bot,
                                    kind: Kind.InputChoice,
                                    props: {
                                        max: 1,
                                        min: 1,
                                        variant: 'button',
                                        label: {
                                            '0': 'Come back later',
                                            '1': 'Try again'
                                        }
                                    }
                                }
                            ];
                            _state.label = 3;
                        case 3:
                            // console.log('callback', envelopes, callbacksRef, convo);
                            stateRef.current = state;
                            (_callbacksRef_current_convo = callbacksRef.current[convo]) === null || _callbacksRef_current_convo === void 0 ? void 0 : _callbacksRef_current_convo.forEach(function(cb) {
                                envelopes.forEach(cb);
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        checkNetworkStatus,
        onHistory,
        apollo
    ]);
    return {
        checkNetworkStatus: checkNetworkStatus,
        status: isConnected ? "connected" : "disconnected",
        subscribe: useCallback(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(convo, callback) {
                var history;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // console.log('subscribe', convo);
                            if (!callbacksRef.current[convo]) callbacksRef.current[convo] = [];
                            callbacksRef.current[convo].push(callback);
                            return [
                                4,
                                getBotHistory(convo)
                            ];
                        case 1:
                            history = _state.sent();
                            if (history.length) {
                                onHistory(history);
                            }
                            // catches errors, should never reject
                            void performTransition(convo, null);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(convo, callback) {
                return _ref.apply(this, arguments);
            };
        }(), [
            performTransition,
            onHistory
        ]),
        unsubscribe: useCallback(function(convo, callback) {
            var _callbacksRef_current_convo;
            // console.log('unsubscribe', convo);
            if (!callbacksRef.current[convo]) return;
            callbacksRef.current[convo] = (_callbacksRef_current_convo = callbacksRef.current[convo]) === null || _callbacksRef_current_convo === void 0 ? void 0 : _callbacksRef_current_convo.filter(function(sub) {
                return sub !== callback;
            });
        }, []),
        send: useCallback(function(convo, payload) {
            // console.log(convo, payload, stateRef.current);
            var isWelcome = convo === 'welcome';
            if (payload.kind) {
                if (payload.ID === 'error-choice' && payload.kind === Kind.InputChoice) {
                    if (payload.props[0] === 0) {
                        var _callbacksRef_current_convo;
                        (_callbacksRef_current_convo = callbacksRef.current[convo]) === null || _callbacksRef_current_convo === void 0 ? void 0 : _callbacksRef_current_convo.forEach(function(cb) {
                            var envelopes = [
                                {
                                    ID: 'nav-home',
                                    from: Actor.Bot,
                                    kind: Kind.SideEffectNavigate,
                                    props: {
                                        routeName: isWelcome ? 'LoggedInWelcome' : 'home'
                                    }
                                }
                            ];
                            envelopes.forEach(cb);
                        });
                    } else {
                        dispatch(StackActions.replace(isWelcome ? 'WelcomeConversation' : 'Conversation', params));
                    }
                    return;
                }
                // catches errors, should never reject
                void performTransition(convo, payload);
            }
        }, [])
    };
}
export function useConversation(convo, completed, handleSideEffect) {
    var lastSentRef = useRef(undefined);
    var queueRef = useRef([]);
    var _useState = _sliced_to_array(useState({
        chat: [],
        input: []
    }), 2), messages = _useState[0], setMessages = _useState[1];
    var _useAccessibilityContext = useAccessibilityContext(), isScreenReaderEnabled = _useAccessibilityContext.isScreenReaderEnabled, isAnnouncingIOS = _useAccessibilityContext.isAnnouncingIOS;
    var isAnnouncingIOSRef = useRef(isAnnouncingIOS);
    isAnnouncingIOSRef.current = isAnnouncingIOS;
    var onHistory = useCallback(function(history, requiresReset) {
        var _msgs_chat;
        var historyIDs = new Set();
        var dedupedHistory = history.filter(function(env) {
            // echo envelopes from the old bot have the same ID as the InputText for which the echo is generated
            var key = "".concat(env.from, ":").concat(env.ID);
            if (historyIDs.has(key)) return false;
            historyIDs.add(key);
            return true;
        });
        var inputHistory = dedupedHistory.filter(function(h) {
            return isInputEnvelope(h);
        });
        var chatHistory = dedupedHistory.filter(function(h) {
            return isChatEnvelope(h);
        });
        var msgs = {
            chat: [],
            input: []
        };
        var chatEnvelopes = chatHistory.map(function(env) {
            return _object_spread_props(_object_spread({}, env), {
                history: true,
                ID: "history_".concat(env.ID)
            });
        }).map(function(env) {
            return env.kind === Kind.ChatText ? getFlatChatTextEnvelopesFromChatTextEnvelope(env) : env;
        }).flat();
        (_msgs_chat = msgs.chat).unshift.apply(_msgs_chat, _to_consumable_array(chatEnvelopes));
        if (inputHistory.length && (!completed || !IS_PRODUCTION)) {
            var lastEcho = _to_consumable_array(chatHistory).reverse().find(function(e) {
                return e.ID.startsWith('echo');
            });
            var lastInput = inputHistory[inputHistory.length - 1];
            var lastInputHasEcho = lastEcho && lastEcho.t > lastInput.t;
            if (!lastInputHasEcho) {
                msgs.input.unshift(lastInput);
            }
        }
        setMessages(function(curr) {
            return requiresReset ? msgs : {
                chat: _to_consumable_array(curr.chat).concat(_to_consumable_array(msgs.chat)),
                input: _to_consumable_array(curr.input).concat(_to_consumable_array(msgs.input))
            };
        });
    }, [
        completed
    ]);
    /* eslint-disable */ var _ref = convo.startsWith(TEST_CONVO_PREFIX) ? useTestMQTT() : useStateMachine(onHistory), checkNetworkStatus = _ref.checkNetworkStatus, status = _ref.status, send = _ref.send, unsubscribe = _ref.unsubscribe, subscribe = _ref.subscribe;
    /* eslint-enable */ useEffect(function() {
        if (!convo) return;
        var callback = function(message) {
            queueRef.current = produce(queueRef.current, function(draft) {
                if (message.kind === Kind.ChatText) {
                    var _draft;
                    var arr = getFlatChatTextEnvelopesFromChatTextEnvelope(message);
                    (_draft = draft).push.apply(_draft, _to_consumable_array(arr));
                } else {
                    draft.push(message);
                }
            });
            incrementRef.current();
        };
        subscribe(convo, callback).catch(function() {
            getErrorEnvelopes({
                connected: true
            }).map(function(env) {
                callback(env);
            });
        });
        return function() {
            unsubscribe(convo, callback);
        };
    // eslint-disable-next-line
    }, [
        convo,
        completed
    ]);
    var newMessageTimeout = useRef(undefined);
    var incrementRef = useRef(function() {});
    incrementRef.current = function addMessage() {
        if (!newMessageTimeout.current && queueRef.current.length && !isAnnouncingIOSRef.current) {
            var queue = queueRef.current;
            var message = queue[0];
            queueRef.current = queue.slice(1);
            setMessages(function(_messages) {
                return produce(_messages, function(msgs) {
                    if (isChatEnvelope(message)) {
                        msgs.chat.push(message);
                    } else if (isInputEnvelope(message)) {
                        msgs.input.push(message);
                    } else if (isSideEffectEnvelope(message)) {
                        if (message.kind === Kind.SideEffectNavigate) {
                            handleSideEffect(_object_spread_props(_object_spread({
                                kind: 'navigate'
                            }, message.props), {
                                routeName: message.props.routeName
                            }));
                        }
                    }
                });
            });
            newMessageTimeout.current = global.setTimeout(function() {
                clearTimeout(newMessageTimeout.current);
                newMessageTimeout.current = undefined;
                incrementRef.current();
            }, getEnvelopeDuration(message, isScreenReaderEnabled) + BUBBLE_APPEAR_OFFSET);
        }
    };
    useEffect(function() {
        if (!isAnnouncingIOS) {
            incrementRef.current();
        }
    }, [
        isAnnouncingIOS
    ]);
    return {
        checkNetworkStatus: checkNetworkStatus,
        status: status,
        messages: messages,
        send: function(message) {
            Sentry.addBreadcrumb({
                category: 'bot',
                message: 'send-envelope',
                data: {
                    ID: message.ID,
                    kind: message.kind,
                    convo: convo
                }
            });
            if (equals(lastSentRef.current, message)) {
                Sentry.captureMessage('Potential duplicate envelope sent by user in bot session', {
                    level: 'warning'
                });
            }
            lastSentRef.current = message;
            // This is a how we fake bot messages that were generated somewhere on the client
            // but we don't care to send to / persist on the server
            if (message.from === Actor.Bot && message.kind === Kind.InputText) {
                setMessages(function(msgs) {
                    return _object_spread_props(_object_spread({}, msgs), {
                        chat: _to_consumable_array(msgs.chat).concat([
                            {
                                ID: message.ID,
                                from: Actor.Bot,
                                kind: Kind.ChatText,
                                props: {
                                    text: [
                                        message.props
                                    ]
                                },
                                t: Date.now()
                            }
                        ])
                    });
                });
                return;
            }
            send(convo, message);
        }
    };
}
